import I1 from '../img/i1.png'
import F1 from '../img/f1.png'
import C3 from '../img/c3.png'
import Fi1 from '../img/fi1.png'

export const heroData = [
  { id: 1, name: 'Icecream', decp: 'Chocolate & Vanilla', price: '5.25', imageSrc: I1 },
  { id: 2, name: 'Strawberries', decp: 'Fresh Strawberries', price: '5.25', imageSrc: F1 },
  { id: 3, name: 'Chicken Kebab', decp: 'Mixed Kebab Plate', price: '5.25', imageSrc: C3 },
  { id: 4, name: 'Fish Kebab', decp: 'Mixed Fish Kebab', price: '5.25', imageSrc: Fi1 },
]

export const categories = [
  { id: 1, name: 'Chicken', urlParanName: 'chicken' },
  { id: 2, name: 'Curry', urlParanName: 'curry' },
  { id: 3, name: 'Rice', urlParanName: 'rice' },
  { id: 4, name: 'Fish', urlParanName: 'fish' },
  { id: 5, name: 'Fruits', urlParanName: 'fruits' },
  { id: 6, name: 'Icecreams', urlParanName: 'icecreams' },
  { id: 7, name: 'Soft Drinks', urlParanName: 'drinks' },
]
